export const arrowSortUp = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="rgba(255,255,255,0.87)"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
  >
    <path d="m280-400 200-200 200 200H280Z" />
  </svg>
);
